import Repository from '@/repositories/repository'

const WebTraderRepository = {
  async getWebTraderData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('web-trader', 'page', params)
  }
}

export default WebTraderRepository
